module.exports = __webpack_public_path__ + "img/EMT-MELA_SpatialResearch.12d5c46e.png";